module.exports = __webpack_public_path__ + "img/section3Card2BrandIcon1.b81e6113.png";